import Store from "App/Store.js";

export default logger => Store.dispatch({type: "logger", logger});
